<div class="datos-card-wrapper">
  <div class="datos-card" [ngClass]="hasPadding ? 'datos-content-padding' : 'p-0'">
    <div class="flex justify-between flex-wrap w-full relative z-index-3">
      <div class="aligner-start mr-3 h-[60px] text-gray-1100 rounded-sm" *ngIf="!!name">
        <div>
          <h3 [attr.data-test]="'list-view-component-product-name-' + name" class="text-heading-old">
            {{ name }}
          </h3>
          <div class="text-standard-old">
            <ng-container *ngIf="state.initialized && state.numberOfEntries">
              <span class="font-semibold">{{ state.numberOfEntries || 0 }}</span>
              {{ state.numberOfEntries === 1 ? 'entry' : 'entries' }}
            </ng-container>
          </div>
        </div>
      </div>
      <div
        class="p-0 generic-ag-wrapper-cta-wrapper grow"
        *ngIf="(!hideSearch || canAdd) && searchFieldPosition === 'outside'"
        [ngStyle]="{ 'max-width': !!name ? '600px' : 'auto' }"
      >
        <ng-container *ngIf="!hideSearch && (hideSearchWhenNoData ? state.hasData : true)">
          <div class="w-full flex items-center">
            <ng-content select="[y42ListViewSearchFields]" class="grow"></ng-content>
            <y42-list-view-search-field
              class="grow"
              [searchCtrl]="searchCtrl"
              [searchLabel]="searchLabel"
              [searchPlaceholder]="searchPlaceholder"
              [searchFieldClasses]="searchFieldClasses"
              [searchFieldAppearance]="searchFieldAppearance"
            ></y42-list-view-search-field>
          </div>
        </ng-container>
        <div matTooltip *ngIf="canAdd">
          <button
            mat-raised-button
            class="generic-add-button"
            color="primary"
            [intercomTarget]="'list-view-add'"
            data-test="button-create-entity"
            (click)="addItem()"
            [y42Permission]="state.addPermissionAllowed"
            [permissionTooltip]="messages?.addPermissionAllowedButtonTooltip || ''"
          >
            {{ addButtonText }}
          </button>
        </div>
        <div class="ml-2 inline-block additional-buttons-wrapper">
          <ng-content select="[y42ListViewAdditionalButtons]"></ng-content>
        </div>
      </div>
    </div>
    <div class="w-full p-0 datos-card-inner-body" [ngClass]="!name && searchFieldPosition === 'inside' ? 'h-full' : ''">
      <mat-sidenav-container [hasBackdrop]="false" class="h-full w-full relative">
        <mat-sidenav
          *ngIf="!hideQuickFilters"
          disableClose
          #sidenav
          [mode]="state.isSmallScreen ? 'push' : 'side'"
          [position]="'start'"
          [opened]="!hideQuickFilters && sideNavOpened && state.hasData"
          class="quick-filter-bar"
        >
          <div class="w-full" [ngClass]="hasPadding ? '' : 'pl-2'">
            <y42-list-view-quick-filters
              [canEdit]="canEdit"
              [defaultQuickFilters]="defaultQuickFilters"
              [quickFilterKey]="quickFilterKey || id"
              [gridApi]="gridApi"
              [columnApi]="columnApi"
              [showLoader]="true"
              (resetView)="resetView()"
              (filterSet)="filterWasSet()"
            ></y42-list-view-quick-filters>
          </div>
        </mat-sidenav>

        <mat-sidenav-content class="h-full relative z-index-3" style="overflow: unset">
          <button
            *ngIf="!hideQuickFilters && state.hasData"
            (click)="toggleSidebar()"
            [matTooltip]="sideNavOpened ? 'Close View' : 'Open View'"
            mat-icon-button
            class="quick-filter-button center-absolute"
          >
            <fa-icon
              class="fs-08 relative"
              [ngStyle]="{ right: sideNavOpened ? '0px' : '-7px' }"
              [icon]="['fal', sideNavOpened ? 'chevron-left' : 'chevron-right']"
            ></fa-icon>
          </button>

          <ng-container *ngIf="!hideSearch && state.hasData && searchFieldPosition === 'inside'">
            <div class="w-full flex h-[55px]">
              <ng-content select="[y42ListViewSearchFields]" class="grow"></ng-content>
              <y42-list-view-search-field
                class="grow"
                [searchCtrl]="searchCtrl"
                [searchLabel]="searchLabel"
                [searchPlaceholder]="searchPlaceholder"
                [searchFieldClasses]="searchFieldClasses"
                [searchFieldAppearance]="searchFieldAppearance"
              ></y42-list-view-search-field>
            </div>
          </ng-container>

          <as-split direction="horizontal" [useTransition]="true" [gutterSize]="1">
            <as-split-area
              [size]="detailViewTmpl && state.activeItem ? 70 : 100"
              class="w-full relative"
              [ngStyle]="{ height: searchFieldPosition === 'inside' ? 'calc(100% - 55px)' : '100%' }"
            >
              <y42-list-view-grid
                [messages]="messages"
                [searchCtrl]="searchCtrl"
                [gridOptions]="gridOptions"
                [columnDefs]="columnDefs"
                [frameworkComponents]="frameworkComponents"
                [hideLoader]="hideLoader"
                [incrementalLoading]="incrementalLoading"
                [addPermissionAllowed]="state.addPermissionAllowed"
                [canAdd]="canAdd"
                (add)="addItem()"
                (gridReady)="onGridReady($event)"
                (gridRowClicked)="rowClicked($event)"
                (gridRowDoubleClicked)="rowDoubleClicked($event)"
                (gridSelectionChanged)="gridSelectionChanged.emit($event)"
                (cellClicked)="cellClicked.emit($event)"
              ></y42-list-view-grid>

              <!-- <button
                class="absolute z-index-3 z-depth-1 bg-gray-1000 small-icon-button"
                matTooltip="Refresh View"
                style="bottom: 10px; right: 3px"
                mat-icon-button
                (click)="getTimeNow()"
                [intercomTarget]="'01-job-dialog-16351'"
              >
                <fa-icon class="text-white" [icon]="['fal', 'undo']"></fa-icon>
              </button> -->
            </as-split-area>

            <as-split-area
              *ngIf="detailViewTmpl && state.activeItem"
              [size]="state.activeItem ? 30 : 0"
              class="h-full w-full relative"
            >
              <div class="expanded-bottom-settings-area">
                <a
                  class="small-icon-button"
                  matTooltip="Redirect Here"
                  mat-icon-button
                  [intercomTarget]="'list-view-detail-redirect'"
                >
                  todo redirect
                  <!-- (click)="closeDialog()" -->
                  <fa-icon [icon]="['fal', 'location-arrow']"></fa-icon>
                </a>
                <button
                  class="small-icon-button"
                  matTooltip="Cancel View"
                  mat-icon-button
                  (click)="closeDetailView()"
                  [intercomTarget]="'list-view-close-detail'"
                >
                  <fa-icon [icon]="['fal', 'times']"></fa-icon>
                </button>
              </div>

              <ng-container *ngTemplateOutlet="detailViewTmpl; context: { $implicit: state.activeItem }">
              </ng-container>
            </as-split-area>
          </as-split>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
    <!-- <img src="assets/images/y42-branding-elements/simple-pattern.svg" class="decoration-image" alt="Background" /> -->
  </div>
</div>
